<template>
  <section class="user-dash__opes card">
    <div class="dashboard__content card-body d-flex px-lg-5">
      <h2 class="heading-secondary">{{ title }}</h2>
      <div class="card my-3" :class="{ 'ope-card--closed': inter.resolved_at }" v-for="(inter, i) in interventions" :key="'running-' + i">
        <div class="card-body mx-lg-3">
          <InterventionHeader :intervention="inter" :collapsible="true" />
          <div class="collapse mt-4" :class="{'show': isShow(inter.id) }" :id="'ope1Details' + inter.id">
            <div class="row">
              <div class="col-12 col-md-6 col-lg-7">
              <div>
                <h3 class="heading-secondary">Client</h3>
                <div class="form-row mt-3">
                  <div class="col-sm col-md-12 col-lg-7" v-if="inter.client.located">
                    <Gmap :id="'client' + inter.client.id" :lat="inter.client.lat" :lng="inter.client.lng" />
                  </div>
                  <div class="col-sm col-md-12 col-lg-5 mt-1 mt-sm-0 mt-md-1 mt-lg-0">
                    <p class="mb-1">
                      <span class="fa-stack fa-lg small mr-h">
                        <i class="fa fa-circle fa-stack-2x" :class="'text-' + $mainColor"></i>
                        <i class="fa fa-address-card-o fa-stack-1x fa-inverse"></i>
                      </span>
                      <span class="heading-primary align-middle">{{ inter.client.name }}</span>
                    </p>
                    <div class="smaller thin">
                      <p class="mb-0">{{ inter.client.phone }}</p>
                      <p class="mb-0">{{ inter.client.email }}</p>
                      <p class="mb-0">{{ inter.client.address }}</p>
                    </div>
                  </div>
                </div>
              </div>
              </div>
              <div class="dash-ope__prdt user-dash__prdt col-12 col-md-6 col-lg-5">
                <div class="mt-4 mt-md-0">
                  <h3 class="heading-secondary">Produit</h3>
                  <div class="prdt-card row">
                    <div class="dash-prdts__img-wrapper prdt-card__img-wrapper col-auto">
                      <img :alt="inter.product.product.name" :src="inter.product.product.image_path || require('@/assets/images/product-placeholder.png')" class="prdt-card__img img-fluid">
                    </div>
                    <div class="prdt-card__details col m-0">
                      <h3 class="prdt-card__name">
                        {{ inter.product.product.name }}
                        <small class="bg-dark text-white px-2" v-if="inter.product.product.stove_type">
                          {{ inter.product.product.stove_type }}
                        </small>
                      </h3>
                      <div class="smaller thin">
                        <p class="mb-2">N° de série :
                          <span class="prdt-card__value" v-if="inter.product.serial_number">
                            {{ inter.product.serial_number }}
                          </span>
                        </p>
                        <p class="mb-2">Date d’achat :
                          <span class="prdt-card__value" v-if="inter.product.formatted_purchased_at">
                            {{ inter.product.formatted_purchased_at }}
                          </span>
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="dash-ope__details col-12 mt-4">
                <h3 class="heading-secondary">Détails</h3>
                <p class="text-info l-spaced mt-3">
                  <strong>Problème rencontré :</strong> {{ inter.problem_description }}
                  <!-- <span class="collapse" id="wordingCollapse"> et c'est la fin.</span>
                  <a aria-controls="wordingCollapse" aria-expanded="false" aria-label="Voir plus/moins" class="read-more collapsed" data-toggle="collapse" href="#wordingCollapse"></a> -->
                </p>
                <p class="text-info l-spaced mb-1">
                  <strong>Description :</strong> {{ inter.description }}
                </p>
              </div>
            </div>
              <div class="row mt-3 mb-1">
                <div class="col-sm">
                  <button
                    type="button"
                    class="dashboard__btn btn rounded-0 btn-block my-1"
                    :class="'btn-outline-' + $mainColor"
                    @click="openPdf(inter.id, inter.pdf_label)">
                    Télécharger la fiche d'intervention
                  </button>
                </div>
                <div class="col-sm mt-3 mt-sm-0">
                  <router-link
                    :to="{ name: 'interventionReport', params: { id: inter.id, reportId: inter.no_report ? 'new' : inter.report.id } }"
                    class="dashboard__btn btn rounded-0 btn-block my-1"
                    :class="'btn-' + $mainColor"
                    @click.native="$scrollToTop">
                    {{ reportFormTitle(inter.no_report) }}
                  </router-link>
                </div>
              </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import InterventionHeader from './InterventionHeader'
import { mapState } from 'vuex'
import Gmap from '@/components/ui/Gmap'

export default {
  name: 'InterventionsSection',
  components: {
    InterventionHeader,
    Gmap
  },
  props: {
    title: String,
    interventions: {
      type: Array,
      default: () => []
    }
  },
  computed: {
    ...mapState(['currentUser', 'userAuth'])
  },
  methods: {
    isShow (id) {
      return id === parseInt(this.$route.query.id)
    },
    reportFormTitle (report) {
      return report ? 'Rédiger un rapport d\'intervention' : 'Éditer le rapport d\'intervention'
    },
    openPdf (id, label) {
      this.$http('/users/' + this.currentUser.id + '/interventions/' + id + '/pdf.pdf', {
        headers: this.userAuth,
        responseType: 'blob'
      }).then(resp => {
        const pdf = new Blob([resp.data], { type: 'application/pdf' })
        let link = document.createElement('a')
        link.href = window.URL.createObjectURL(pdf)
        link.download = `${label}.pdf`
        link.click()
      })
    }
  }
}
</script>
